// @flow

import { type OpenedIncomingPayment } from './types';
import { getCheckoutPaymentOptions, getCheckoutPaymentOptionsV2 } from './get-checkout-payment-options';

export function getExternalPayProviders(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const checkoutPaymentOptions = getCheckoutPaymentOptionsV2(incomingPayment) ?? getCheckoutPaymentOptions(incomingPayment);
  const externalPayProviders = checkoutPaymentOptions?.externalpayprovider;

  return Array.isArray(externalPayProviders) ? externalPayProviders : [];
}
